import styled from "styled-components";

export const ContainerDiv = styled("div")<{
    colGap: number;
}>`
    margin: ${(props) => props.colGap || 0}px 0;
`;
